import { render, staticRenderFns } from "./NavigationItemArrow.vue?vue&type=template&id=aad2b4e0&"
import script from "./NavigationItemArrow.vue?vue&type=script&lang=js&"
export * from "./NavigationItemArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports